import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import Poppers from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Notifications from "@material-ui/icons/Notifications";
// redux components
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// core components
import Button from "components/CustomButtons/Button.jsx";

import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle";

import * as authActionCreators from "actions/auth";
import * as usersActionCreator from "actions/users";

import { get_notifications_viewed } from "utils/http";

function mapStateToProps(state) {
    return {
        token: state.auth.token,
        notifications: state.users.notifications,
        notificationsCount: state.users.notificationsCount,
        notificationsNewCount: state.users.notificationsNewCount,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({...authActionCreators, ...usersActionCreator}, dispatch);
}

class HeaderLinks extends React.Component {
  state = {
    menuOpened: null,
    notificationsOpened: false,
    notificationsViewed: false,
  };

  componentDidMount() {
      this.props.getNotification(this.props.token)
  }

    handleMenuClick = () => {
    this.setState({ menuOpened: !this.state.menuOpened });
  };

  handleMenuClose = (event) => {
    if (this.anchorMenuEl.contains(event.target)) {
        return;
    }
    this.setState({ menuOpened: false });
  };

    handleNotificationsClick = () => {
        if (!this.state.notificationsViewed){
            get_notifications_viewed(this.props.token).catch(() => {});
        }
        this.props.notificationsCount && this.setState({
            notificationsOpened: !this.state.notificationsOpened,
            notificationsViewed: true,
        });
    };

    handleNotificationsClose = (event) => {
        if (this.anchorNotificationEl.contains(event.target)) {
            return;
        }
        this.setState({ notificationsOpened: false });
    };

  render() {
    const { classes, notifications, notificationsNewCount } = this.props;
    const { menuOpened, notificationsOpened, notificationsViewed } = this.state;
    return (
      <div>
          <div className={classes.manager}>
              <Button
                  buttonRef={node => {
                      this.anchorNotificationEl = node;
                  }}
                  color={window.innerWidth > 959 ? "transparent" : "white"}
                  justIcon={window.innerWidth > 959}
                  simple={!(window.innerWidth > 959)}
                  aria-owns={notificationsOpened ? "notification-menu-list-grow" : null}
                  aria-haspopup="true"
                  onClick={this.handleNotificationsClick}
                  className={classes.buttonLink}
              >
                  <Notifications className={classes.icons} />
                  {notificationsNewCount && !notificationsViewed ? (<span className={classes.notifications}>{notificationsNewCount}</span>) : null}
                  <Hidden mdUp implementation="css">
                      <p onClick={this.handleClick} className={classes.linkText}>
                          Уведомления
                      </p>
                  </Hidden>
              </Button>
              <Poppers
                  open={notificationsOpened}
                  anchorEl={this.anchorNotificationEl}
                  transition
                  disablePortal
                  className={
                      classNames({ [classes.popperClose]: !notificationsOpened }) +
                      " " +
                      classes.popperNav
                  }
              >
                  {({ TransitionProps, placement }) => (
                      <Grow
                          {...TransitionProps}
                          id="notification-menu-list-grow"
                          style={{
                              transformOrigin:
                                  placement === "bottom" ? "center top" : "center bottom"
                          }}
                      >
                          <Paper>
                              <ClickAwayListener onClickAway={this.handleNotificationsClose}>
                                  <MenuList role="menu">
                                      {notifications.map((e, key) => (
                                          <MenuItem className={classes.dropdownItem} key={key}>
                                              {e.text}
                                          </MenuItem>
                                      ))}
                                  </MenuList>
                              </ClickAwayListener>
                          </Paper>
                      </Grow>
                  )}
              </Poppers>
          </div>
        <Button
            color={window.innerWidth > 959 ? "transparent" : "white"}
            justIcon={window.innerWidth > 959}
            simple={!(window.innerWidth > 959)}
            aria-label="Person"
            aria-controls="user-menu"
            aria-haspopup="true"
            className={classes.buttonLink}
            onClick={this.handleMenuClick}
            buttonRef={node => {
                this.anchorMenuEl = node;
            }}
        >
          <Person className={classes.icons} />
          <Hidden mdUp>
            <p onClick={this.handleMenuClick} className={classes.linkText}>Профиль</p>
          </Hidden>
        </Button>
          <Poppers
              open={menuOpened}
              anchorEl={this.anchorMenuEl}
              transition
              disablePortal
              className={
                  classNames({ [classes.popperClose]: !menuOpened}) +
                  " " +
                  classes.popperNav
              }
          >
              {({ TransitionProps, placement }) => (
                  <Grow
                      {...TransitionProps}
                      id="user-menu-list-grow"
                      style={{
                          transformOrigin:
                              placement === "bottom" ? "center top" : "center bottom"
                      }}
                  >
                      <Paper>
                          <ClickAwayListener onClickAway={this.handleMenuClose}>
                              <MenuList role="menu">
                                  <MenuItem
                                      onClick={() => this.props.logoutAndRedirect()}
                                      className={classes.dropdownItem}
                                  >
                                      Выйти из аккаунта
                                  </MenuItem>
                              </MenuList>
                          </ClickAwayListener>
                      </Paper>
                  </Grow>
              )}
          </Poppers>
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  logoutAndRedirect: PropTypes.func,
  getNotification: PropTypes.func,
  token: PropTypes.string,
  notifications: PropTypes.array,
  notificationsCount: PropTypes.number,
};

export default withStyles(headerLinksStyle)(connect(mapStateToProps, mapDispatchToProps)(HeaderLinks));



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx